'use client';

import config from '@actr/config';
import { ButtonSizes } from '@actr/ui/src/components/_atoms/button';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { Container } from '@actr/ui/src/components/container';
import React, { useEffect } from 'react';

import SeoButton from '@/ui/seo-button';

import widgetsLog, { WidgetsLog } from '../../../logs/base';
import * as Styled from './style.css';

interface NotFoundProps {
  disableButtons?: boolean;
  textContent?: string;
}

const NotFoundComponent: React.FC<NotFoundProps> = props => {
  const { disableButtons, textContent } = props;

  useEffect(() => {
    widgetsLog.send(WidgetsLog.ROUTE_ERROR, {
      url: window.location.href
    });
  }, []);

  return (
    <div className={Styled.Container}>
      <Container>
        <div className={Styled.NotFoundWrapper}>
          <img
            className={Styled.Image}
            src={`${config.cmsMediaUrl}images/404error.png`}
            alt="404"
          />
          <div className={Styled.Texts}>
            <Text font="title.xl">
              Ошибка 404
            </Text>
            <Text font="paragraph.m">
              { textContent || 'Такой страницы нет' }
            </Text>
          </div>
          {!disableButtons && (
          <div
            className={Styled.ButtonWrapper}>
            <SeoButton
              url="/"
              size={ButtonSizes.M}
              className={Styled.ButtonWidth}>
              На главную
            </SeoButton>
          </div>
          )}
        </div>
      </Container>
    </div>
  );
};

export default NotFoundComponent;
